import { v4 as uuidv4 } from 'uuid'

export default function prepareItemsForReturn(items) {
  return items.map(item => ({ ...item, id: uuidv4(), quantity: -item.quantity }))
}